import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import { COUNTRIES, countriesClosed } from '~/const/locales';
var marketClosed = function marketClosed(_ref) {
  var market = _ref.market;
  if (COUNTRIES[market] !== market) {
    throw new Error("marketClosed: ".concat(market, " is not a supported value"));
  }
  return countriesClosed.includes(market);
};
export default marketClosed;